import type MailFolderNodeViewState from "../store/schema/MailFolderNodeViewState";
import { getStore } from "../store/store";

const changedViewStates = new WeakSet<MailFolderNodeViewState>();

export function markMailboxFolderExpansionChanged(folderId: string): void {
    const viewState = getStore().folderNodeViewStates.get(folderId);
    if (viewState) {
        changedViewStates.add(viewState);
    }
}

export function hasMailboxFolderExpansionChanged(viewState: MailFolderNodeViewState | undefined): boolean {
    return !!viewState && changedViewStates.has(viewState);
}
